
import {getDistance} from 'geolib';
import {AllRegions, Region} from 'utils/region';

// We multiply by 1610 meters per mile
const maxMetersToRegion = 1610 * 100;

export const calcRegion = (coords?: {lat: number; lng: number}): Region | undefined => {
	if (!coords) {
		return;
	}

	let closest = {
		region: undefined as (Region | undefined),
		distance: 0,
	};

	for (const region of AllRegions) {
		const distance = getDistance(coords, region.center);
		if (!closest.region || distance < closest.distance) {
			closest = {
				region,
				distance,
			};
		}
	}

	if (closest.distance > maxMetersToRegion) {
		return;
	}

	return closest.region;
};
